<template>
  <v-container class="pa-0" fluid>
    <v-container class="header" fluid>
      <v-layout column align-center justify-center>
        <v-col xl="12" lg="12" md="12" sm="12" class="pb-0">
          <v-layout align-center style="height: 130px">
            <v-layout row style="position: absolute">
              <v-img
                @click="goBack()"
                height="45"
                width="45"
                class="shrink pointer"
                contain
                :src="require('../../assets/back.png')"
              />
              <div class="ml-3" style="color: #000; width: 96px">Back to profuse.md</div>
            </v-layout>
            <v-col xl="8" lg="9" md="8" sm="12" class="pb-0 mx-auto">
              <Toolbar theme="dark" />
            </v-col>
          </v-layout>
        </v-col>

        <v-col xl="6" lg="6" md="8" sm="10">
          <div class="app-title mx-auto mt-9">Smart Blocks</div>

          <div class="app-description mx-auto">Fill the board. It’s not easy!</div>

          <v-row class="mt-9 pt-5 mx-auto" justify="center">
            <v-flex shrink mb-5 class="pointer">
              <v-img
                @click="openAppStore"
                height="58"
                width="195"
                contain
                :src="require('../../assets/app_store.png')"
              />
            </v-flex>

            <v-flex shrink class="pointer">
              <v-img
                @click="openPlayStore"
                height="58"
                width="195"
                contain
                :src="require('../../assets/play_market.png')"
              />
            </v-flex>
          </v-row>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="features" fluid>
      <v-layout justify-center>
        <v-col xl="8" lg="10" md="10" sm="12">
          <v-layout row justify-space-between align-center>
            <v-col md="6" sm="12">
              <v-img contain :src="require('../../assets/SmartBlocks/app_screenshots.png')" />
            </v-col>

            <v-col md="6" sm="12" class="pl-9">
              <div class="features-title">Main Features</div>
              <div class="features-item">■ Over 200 levels</div>
              <div
                class="features-item"
              >■ A unique solution to each level - no way you can solve it differently than others</div>
              <div class="features-item">■ Extremely challenging at times</div>
              <div class="features-item">■ In frustration? Use hints - we won’t tell anyone :)</div>
              <div class="features-item">■ Perfect IQ booster</div>
              <div class="features-item">■ Challenge your friends who think it’s easy ;)</div>
            </v-col>
          </v-layout>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="download" fluid>
      <v-layout justify-center>
        <v-col xl="6" lg="6" md="6" sm="10">
          <div class="download-app">Download the Free Smart Blocks Puzzle App</div>

          <v-row class="mt-9 pt-5 mx-auto bottom-store-buttons" justify="center">
            <v-flex shrink mb-5 class="pointer">
              <v-img
                @click="openAppStore"
                height="58"
                width="195"
                contain
                :src="require('../../assets/app_store.png')"
              />
            </v-flex>

            <v-flex shrink class="pointer">
              <v-img
                @click="openPlayStore"
                height="58"
                width="195"
                contain
                :src="require('../../assets/play_market.png')"
              />
            </v-flex>
          </v-row>
        </v-col>
      </v-layout>
    </v-container>

    <v-container class="footer" fluid>
      <v-layout justify-center>
        <v-col xl="8" lg="10" md="10" sm="10">
          <v-toolbar color="transparent" height="100" flat>
            <v-flex shrink align-center justify-center class="logo">
              <v-img
                height="100"
                width="100"
                contain
                :src="require('../../assets/SmartBlocks/logo.png')"
              />
            </v-flex>

            <v-spacer />

            <v-layout row class="ml-9" justify-end>
              <v-btn text>
                <div class="toolbar-btn" :style="{ color: 'black' }">How it Use</div>
              </v-btn>

              <v-btn text>
                <div class="toolbar-btn" :style="{ color: 'black' }">Privacy Policy</div>
              </v-btn>
            </v-layout>
          </v-toolbar>
        </v-col>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import Toolbar from "./components/Toolbar";
export default {
  components: {
    Toolbar
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    openAppStore() {
      window.open(
        "https://apps.apple.com/us/app/smart-blocks-puzzle/id1498638665",
        "_blank"
      );
    },
    openPlayStore() {
      window.open(
        "https://play.google.com/store/apps/details?id=md.profuse.smartblocks",
        "_blank"
      );
    }
  }
};
</script>

<style scoped>
.header {
  background-image: url("../../assets/SmartBlocks/bg_header.png");
  background-size: cover;
  background-position: center;
  background-color: #f0e7de;
  min-height: 1000px;
  height: 100vh;
}
.app-title {
  font-family: "PassionOne";
  font-size: 90px;
  line-height: 1.14;
  text-align: center;
  color: #000000;
}
.app-description {
  font-family: "PassionOne";
  font-size: 50px;
  line-height: 1.32;
  text-align: center;
  color: #000000;
  max-width: 380px;
}
.features {
  background-color: #f0e7de;
}
.features-title {
  font-family: "PassionOne";
  font-size: 60px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
  margin-bottom: 50px;
}
.features-item {
  font-family: "HelveticaNeue";
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.13;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
  margin-top: 25px;
}
.download {
  background-image: url("../../assets/SmartBlocks/bg_blocks.png");
  background-size: contain;
  background-position: center;
  background-color: #f0e7de;
}
.download-app {
  font-family: "PassionOne";
  font-size: 60px;
  font-weight: bold;
  line-height: 1.1;
  text-align: center;
  color: #000000;
  margin-top: 150px;
  margin-bottom: 50px;
}
.bottom-store-buttons {
  margin-bottom: 280px;
}
.footer {
  background-color: #f0e7de;
}
.pointer {
  cursor: pointer;
}
.toolbar-btn {
  font-family: "Montserrat";
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.22;
  letter-spacing: normal;
  text-align: left;
  color: #fafafa;
  text-transform: none;
}
</style>